import { notFound } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";

import { getGetMeQueryOptions } from "../../api/generated/endpoints/identity/identity";

/**
 * The staff pages render for staff only, from the server's `Me.is_staff`; anyone else sees
 * not-found, as the `/v1/staff/*` routes answer 404 to them. The API stays the gate.
 */
export async function requireStaff(queryClient: QueryClient): Promise<void> {
  const me = await queryClient.ensureQueryData(getGetMeQueryOptions());
  if (!me.is_staff) throw notFound();
}
